import React, { useEffect, useContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SearchLocationPage from "../pages/SearchLocationPage";
import EnrollementInterestPage from "../pages/EnrollemtInterestPage";
import RegistrationFormPage from "../pages/RegistrationFormPage";
import RegistrationFormPageInt from "../pages/RegistrationFormPageInt";
import R3ParentInformation from "../components/leloForm/R3ParentInformation";
import InformationActionPage from "../pages/InformationActionPage";

import AddInterestPage from "../pages/admin/AddInterestPage";
import AddContactNote from "../components/interestAdmin/AddContactNote";
import EditInterestForm from "../components/interestAdmin/EditInterestForm";
import InterestFormPage from "../pages/admin/InterestFormPage";
import EmailLoggerPage from "../pages/admin/EmailLoggerPage";
import InterestFormListPage from "../pages/admin/InterestFormListPage";



import AddRegistrationPage from "../pages/admin/AddRegistrationPage";
import RegistrationAdminFormPage from "../pages/admin/RegistrationFormPage";
import RegistrationFormListPage from "../pages/admin/RegistrationFormListPage";
import ScheduledOrientationPage from "../pages/admin/ScheduledOrientationPage";
import EmailLoggerFormListPage from "../pages/admin/EmailLoggerFormListPage";

import InteresessionListPage from "../pages/admin/IntersessionListPage";
import EditCoursesPage from "../pages/admin/EditCoursesPage";
import EditCourseOfferingPage from "../pages/admin/EditCourseOfferingPage";
import EditConfirmationPage from "../pages/admin/EditConfirmationPage"
import EditEmailConfirmation from "../pages/admin/EditEmailConfirmation";
import AddLELORegistrationProfile from "../components/intersession/AddRegistrationProifle";
import EditLELORegistrationProfile from "../components/intersession/EditRegistrationProfile";
import EditFinalCourse from "../pages/admin/EditFinalCourse";

import AdminHome from "../pages/admin/HomePage";
import AdminLogin from "../pages/admin/LoginPage";
import AppPermissionsPage from "../pages/admin/AppPermissionsPage";

import AuthContext from "../context/auth/authContext";
import AdminInterestContext from "../context/adminInterest/adminInterestContext";

import AdminRegistrationContext from "../context/adminRegistration/adminRegistrationContext";

import NotificationModal from "../components/utilities/NotificationModal";

import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";
import ContributorRoute from "./ContributorRoute";

import setAuthToken from "../functions/auth_header";

import "../scss/main.scss";

import R1StudentCharterInformation from "../components/leloForm/R1StudentCharterInformation";
import R2StudentInformation from "../components/leloForm/R2StudentInformation";
import R4PhysicalAddress from "../components/leloForm/R4PhysicalAddress";
import R5MailingAddress from "../components/leloForm/R5MailingAddress";
import R6Course from "../components/leloForm/R6Course";
import R7MasterAgreement from "../components/leloForm/R7MasterAgreement";
import LeloResponse from "../components/leloForm/LeloResponse";
import LeloListPage from "../pages/admin/LeloFormListPage";
import LeloFormPage from "../pages/admin/LeloFormPage";
import EditLeloForm from "../components/leloAdmin/EditLeloForm";
import PreRegistrationModal from "../components/leloAdmin/PreRegistration";
import SessionExpired from "../components/leloForm/SessionExpired";
import InvalidateLink from "../components/leloForm/InvalidateLink";
import NotFound from "../components/leloForm/NotFound";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const MainRouter = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;
  const adminInterestContext = useContext(AdminInterestContext);
  const { getEntries } = adminInterestContext;
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { notificationBanner } = adminRegistrationContext;

  useEffect(() => {
    loadUser();
  }, []);
  return (
    <Router>
      {notificationBanner.visible && <NotificationModal />}
      <Routes>
      <Route path="/" element={<SearchLocationPage />} />
      <Route path="/interest" element={<EnrollementInterestPage />} />
      <Route path="/register" element={<RegistrationFormPage />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/information" element={<InformationActionPage />} />
      <Route path="/register-interest" element={<RegistrationFormPageInt />} />

      {/* <Route
        exact
        path="/forms/:permalink/:_uuid/:LeloRegistrationProfile"
        element={<R1StudentCharterInformation />}
      /> */}
      <Route
        path="/forms/:permalink/:_uuid"
        element={<R1StudentCharterInformation />}
      />
      {/* <Route
        exact
        path="/forms/:permalink/:_id"
        element={<R1StudentCharterInformation />}
      /> */}
      <Route
        path="/forms/:permalink"
        element={<R1StudentCharterInformation />}
      />
      {/* <Route exact path="/sessionExpired/:permalink/:_id" element={<SessionExpired />} />
      <Route exact path="/sessionExpired/:permalink/:_uuid/:LeloRegistrationProfile" element={<SessionExpired />} /> */}

      <Route path="/sessionExpired/:permalink" element={<SessionExpired />} />
      <Route path="/sessionExpired/:permalink/:_uuid" element={<SessionExpired />} />
      <Route path="/invalidateLink/:permalink/:_uuid" element={<InvalidateLink />} />
      <Route path="/NotFound/:permalink" element={<NotFound />} />
      <Route path="/leloStudent" element={<R2StudentInformation />} />
      <Route path="/leloStudent1" element={<R3ParentInformation />} />
      <Route path="/leloStudent2" element={<R4PhysicalAddress />} />
      <Route path="/leloStudent3" element={<R5MailingAddress />} />
      <Route path="/leloStudent4" element={<R6Course />} />
      <Route path="/leloStudent5" element={<R7MasterAgreement />} />
      <Route path="/response-lelo" element={<LeloResponse />} />
      <Route
        path="/edit-courses/:permalink/:id"
        element={<EditCoursesPage />}
      />
      <Route path="/dashboard" element={<PrivateRoute component={AdminHome} />} />
      <Route path="/permissions" element={<AdminRoute component={AppPermissionsPage} />} />
      {/* <AdminRoute exact path="/intersession" component={} /> */}
      <Route
        path="/interest-forms"
        element={<PrivateRoute component={InterestFormListPage} />}
      />
      <Route
        path="/email-logs"
        element={<PrivateRoute component={EmailLoggerFormListPage} />}
      />
      <Route path="/contactNote" element={<PrivateRoute component={AddContactNote} />} />
      <Route
        path="/editInterestForm/:_id"
        element={<PrivateRoute component={EditInterestForm} />}
      />
      <Route
        path="/intersession"
        element={<PrivateRoute component={InteresessionListPage} />}
      />

      <Route path="/lelo-forms" element={<PrivateRoute component={LeloListPage} />} />
      <Route path="/lelo-forms/:id" element={<PrivateRoute component={LeloFormPage} />} />
      <Route path="/editLeloForm/:_id" element={<PrivateRoute component={EditLeloForm} />} />
      <Route
        path="/pre-forms/:permalink/:LeloRegistrationProfile"
        element={<PrivateRoute component={PreRegistrationModal} />}
      />
      <Route
        path="/addLELO"
        element={<PrivateRoute component={AddLELORegistrationProfile} />}
      />
      <Route
        path="/editLELO/:id"
        element={<PrivateRoute component={EditLELORegistrationProfile} />}
      />
     <Route
        path="/edit-courseOfferings/:charter/:charter_id/:name/:courseid/:permalink/:id"
        element={<PrivateRoute component={EditCourseOfferingPage} />}
      />
      <Route
        path="/edit-Finalcourse/:charter/:charter_id/:name/:courseid/:permalink/:id"
        element={<PrivateRoute component={EditFinalCourse} />}
      />

      <Route
        path="/edit-confirmation/:charter_id/:name/:courseid/:permalink/:id"
        element={<PrivateRoute component={EditConfirmationPage} />}
      />
      <Route
        path="/edit-email-confirmation/:charter_id/:name/:courseid/:permalink/:id"
        element={<PrivateRoute component={EditEmailConfirmation} />}
      />

      <Route
        path="/add-interest"
        element={<ContributorRoute component={AddInterestPage} />}
      />
      <Route
        path="/interest-forms/:id"
        element={<PrivateRoute component={InterestFormPage} />}
      />
      <Route
        path="/email-logger/:id"
        element={<PrivateRoute component={EmailLoggerPage} />}
      />
      <Route
        path="/registration-forms"
        element={<PrivateRoute component={RegistrationFormListPage} />}
      />
      <Route
        path="/scheduled-orientations"
        element={<PrivateRoute component={ScheduledOrientationPage} />}
      />
      <Route
        path="/add-registration"
        element={<ContributorRoute component={AddRegistrationPage} />}
      />
      <Route
        path="/registration-forms/:id"
        element={<PrivateRoute component={RegistrationAdminFormPage} />}
      />
      </Routes>
    </Router>
  );
};

export default MainRouter;
